import React, { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { PhoneIncoming, PhoneOutgoing } from "lucide-react";
import { fmtWhen } from "@/components/helm/SmsInbox";

// Helm call history: the rep's own call sessions (admins see all reps).
export const CallHistory = () => {
  const [calls, setCalls] = useState(null);
  const load = useCallback(async () => {
    try { const { data } = await api.get("/telephony/calls/mine"); setCalls(data.calls || []); }
    catch { setCalls([]); }
  }, []);
  useEffect(() => { load(); const t = setInterval(load, 20000); return () => clearInterval(t); }, [load]);

  return (
    <div className="mt-6 rounded-xl border-2 border-[#E5E5E0] bg-white overflow-hidden" data-testid="call-history">
      <div className="px-4 py-3 bg-[#F8F8F5] border-b"><h2 className="text-sm font-bold text-[#0B192C]">Call history</h2></div>
      {calls === null && <p className="px-4 py-3 text-xs text-[#9CA3AF]">Loading…</p>}
      {calls && calls.length === 0 && <p className="px-4 py-3 text-xs text-[#9CA3AF]" data-testid="call-history-empty">No calls yet.</p>}
      <ul className="divide-y">
        {(calls || []).map((c) => (
          <li key={c.id} className="px-4 py-2.5 flex items-center gap-3 text-sm" data-testid={`call-row-${c.id}`}>
            {c.direction === "inbound" ? <PhoneIncoming className="w-4 h-4 text-[#047857]" /> : <PhoneOutgoing className="w-4 h-4 text-[#1E3E62]" />}
            <span className="font-semibold text-[#0B192C]">{c.direction === "inbound" ? "Inbound" : "Call — agent first"}</span>
            <span className="text-xs text-[#475569]">{c.other_number || "—"} · line {c.business_number}</span>
            <span className={`ml-auto text-xs font-semibold ${c.bridged ? "text-[#047857]" : "text-[#9A3412]"}`}>
              {c.bridged ? "Connected" : c.status}{c.simulated ? " (sim)" : ""}
            </span>
            <span className="text-[11px] text-[#9CA3AF]">{fmtWhen(c.created_at)}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};
